import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const VotingPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default VotingPage;
